// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__26GUI","clinicsSelect":"TableHeading_clinicsSelect__1DoFC"};